(function() {
    'use strict';
    angular
            .module('abcQualityMatchApp')
            .factory('TicketMaterial', TicketMaterial);

    TicketMaterial.$inject = ['$resource'];

    function TicketMaterial($resource) {
        var resourceUrl = 'api/ticket-materials/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
